import { render, staticRenderFns } from "./updateProductPrice.vue?vue&type=template&id=cfb20eb0"
import script from "./updateProductPrice.vue?vue&type=script&lang=js"
export * from "./updateProductPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports